import type { FC } from "react"
import React from "react"
import type { RadioProps } from "@chakra-ui/react"
import { Text, Box, Flex, useRadio, Radio, Stack, Icon } from "@chakra-ui/react"

import type { SupportType } from "query/graphql"
import type { VoteStyle } from "common/helpers/voteStyle"

type Props = {
  label: string
  voteStyle: VoteStyle
}

const VoteCastingOption: FC<Props & RadioProps> = ({
  label,
  voteStyle,
  ...radioProps
}) => {
  const { color, colorScheme, icon } = voteStyle

  const { getInputProps, getCheckboxProps } = useRadio(radioProps)

  const input = getInputProps()
  const checkbox = getCheckboxProps()

  const innerRadioProps = Object.fromEntries(
    Object.entries(radioProps).filter(([key]) => key !== "children"),
  )

  const value: SupportType | undefined = radioProps.value
    ? (radioProps.value as SupportType)
    : undefined

  const border = value ? `1px solid ${color} !important` : "gray.light"

  const labelColor = value && radioProps.isChecked ? color : "gray.500"

  return (
    <Box as="label">
      <input {...input} />
      <Box
        {...checkbox}
        _checked={{
          border,
        }}
        _hover={{
          border,
        }}
        aria-hidden="false"
        border="gray.light"
        cursor="pointer"
        px={4}
        py={3}
        rounded="base"
      >
        <Flex align="center" justify="space-between">
          <Stack isInline align="center" spacing={2}>
            <Icon
              as={icon}
              border="1px solid #718096"
              borderRadius="50%"
              boxSize={5}
              color={labelColor}
            />
            <Text color={labelColor} textStyle="body.regular.lg">
              {label}
            </Text>
          </Stack>
          <Radio colorScheme={colorScheme} {...innerRadioProps} />
        </Flex>
      </Box>
    </Box>
  )
}

export default VoteCastingOption
